module.exports = __webpack_public_path__ + "img/img14.4f875410.png";